module.exports = __webpack_public_path__ + "media/site/fonts/TheNorthernBlockLtd-NeoGram-Regular-2709cb96d3f0f3d467456192ae594f16.otf";